import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { browserHistory } from 'react-router'
import { Alert } from 'react-bootstrap'
import * as actions from '../../state/actions'
import * as storage from '../../utils/storage'

class Base extends Component {

    componentDidMount() {
        var self = this
        var promise = Promise.resolve()
        if (!self.props.profile && storage.get(storage.accessTokenKey)) {
            promise = promise.then(() => {
                return self.props.actions.userGetProfile()
            })
        }
        promise = promise.then(() => {
            return self.props.actions.isReady()
        })

        return promise
    }

    componentDidUpdate() {
        var self = this
        var location = self.props.routing && self.props.routing.locationBeforeTransitions
        if (self.props.isReady && !self.props.profile && location && location.pathname !== '/manager/login') {
            browserHistory.push('/manager/login')
        } else if (self.props.isReady && self.props.profile && location && (location.pathname === '/manager/login' || location.pathname === '/manager') || location.pathname === '/manager/') {
            if (self.props.profile && self.props.profile.profile) {
                if (self.props.profile.profile > 0 && self.props.profile.profile <= 1000) {
                    browserHistory.push('/manager/' + self.props.profile.app.codename + '/dashboard')
                } else if (self.props.profile.profile === 2000) {
                    browserHistory.push('/manager/app')
                } else {
                    browserHistory.push('/manager/login')
                }
            }
        }


        if (self.props.api && self.props.api.error) {
            if (self.props.api.error.response && self.props.api.error.response.status && self.props.api.error.response.status === 401) {
                if (browserHistory.getCurrentLocation().pathname !== '/manager/login') {
                    browserHistory.push('/manager/login')
                }
            } else {
                setTimeout(_ => {
                    self.props.actions.apiClean()
                    if (self.props.profile && self.props.profile.app && self.props.profile.app.codename) {
                        browserHistory.push('/manager/' + self.props.profile.app.codename + '/dashboard')
                    }
                }, 5000)
            }
        }
    }

    render () {
        var self = this
        var alert

        const api = self.props.api
        if (api && api.error && !(api.error.response && api.error.response.status && api.error.response.status === 401)) {
            var extraInfo1
            var extraInfo2
            if (api.error.detail) {
                extraInfo1 = <p>{ api.error.detail }</p>
            }
            if (api.error.stack) {
                extraInfo2 = <p>{ api.error.stack }</p>
            }
            alert = (
                <div>
                    <br/>
                    <Alert id="alertError" bsStyle="danger" onDismiss={self.props.actions.apiClean.bind(self)}>
                        <strong>{ api.error.message }</strong>
                        { extraInfo1 }
                        { extraInfo2 }
                    </Alert>
                    <br/>
                </div>
            )
        }
        return (
            <div>
                { process.env.MT_ENV === 'development' && alert }
                { self.props.children }
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        api: state.api,
        isReady: state.isReady,
        profile: state.profile,
        routing: state.routing
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}
export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Base)



// WEBPACK FOOTER //
// ./containers/Base/index.js